import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Breadcrumb, Col, Divider, Dropdown, Flex, Form, Modal, Row, Space, Switch, Button, Card } from "antd";
import { CardContainer } from "components/elements";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/yearAccumulateSchema";

import styles from "../styles/YearAccumulateList.module.css";
import { Formik } from "formik";
import { Input, Select } from "components/form";
import { useSelector } from "react-redux";
import YearAccumulateFilter from "./YearAccumulateFilter";
import { useState } from "react";
import TableAntd from "components/elements/Table/Table";
import { formatDateTime } from "utils/formatter";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

const YearAccumulateList = ({
  initialValues = {},
  yearAccumulateList = [],
  isLoading = false,
  isModalOpen = false,
  pagination = {},
  onSearch = () => { },
  onStatus = () => { },
  onDelete = () => { },
  onChange = () => { },
  onCreate = () => { },
  onEdit = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  amountIncomeDeductionOptions = [],
}) => {
  // console.log("onSubmit", onSubmit);
  // yearAccumulateList.forEach((yearAccumulateList, index) => { yearAccumulateList.serial = index + 1; });
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [useFilter, setUseFilter] = useState(false);
  const columns = [
    {
      title: (
        <div className="text-table">{t("common.index")}</div>
      ),

      dataIndex: "id",
      key: "id",
      width: "10%",
      align: "center",
      render: (text, record, index) => index + 1
    },
    {
      title: <div className="text-table">{t("year_accumulate_list.label.Accumulate_name")}</div>,
      dataIndex: "accumulateName",
      key: "accumulateName",
      width: "20%",
      align: "center",
      sorter: (a, b) => a.accumulateName.length - b.accumulateName.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return record.accumulateNameEn;
        }
        return record.accumulateName;
      },
    },
    {
      title: <div className="text-table">{t("year_accumulate_list.label.Amount_Income_Deduction")}</div>,
      dataIndex: "AmountIncomeDeduction",
      key: "AmountIncomeDeduction",
      width: "20%",
      sorter: (a, b) => a.incomeDeduction.name.length - b.incomeDeduction.name.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return record.incomeDeduction.nameEn;
        }
        return record.incomeDeduction.name;
      },
    },
    {
      title: <div className="text-table">{t("year_accumulate_list.label.last_modified")}</div>,
      ddataIndex: "updateDate",
      key: "lastModified",
      sorter: (a, b) => {
        const { createBy = null, updateBy = null, updateDate, createDate } = a;
        return updateDate ? "updateDate" : "createDate"
      },
      render: (_, record) => {

        const { createBy = null, updateBy = null, updateDate, createDate } = record;
        let lastModified = updateBy ?? createBy
        const name =
          i18n.language === "en" && lastModified?.nameEn
            ? lastModified?.nameEn
            : lastModified?.name;
        return (
          <>
            {name}
            <br />
            {formatDateTime(updateDate ?? createDate)}
          </>
        );
      },
    },
    {
      title: (
        <div className="text-table">{t("year_accumulate_list.label.status")}</div>
      ),
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING",
      "DELETE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING") ? {
      title: <div className="text-table">{t("action.action")}</div>,
      key: "action",
      width: "10%",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                // {
                //   key: "1",
                //   label: (
                //     <a
                //       href={`/employee/${record.employeeId}`}
                //       style={{ color: "grey", fontSize: "14px" }}
                //     >
                //       {t("action.view")}
                //     </a>
                //   ),
                //   icon: (
                //     <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                //   ),
                // },
                roles.includes("UPDATE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING") && {
                  key: "2",
                  onClick: () => onDelete(record.accumulateId),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];


  return (
    <MainLayout>
      <Modal
        title={
          initialValues.accumulateId ? t("common.edit") : t("common.create")
        }
        open={isModalOpen}
        closable={false}
        onOk={() => { }}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "year_accumulate_cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        width="511px"
        footer={null}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VALUES, ...initialValues }}
          onSubmit={onSubmit}
          validationSchema={schema}
        >
          {({ values = {}, submitForm, setFieldValue, resetForm }) => {
            return (
              <Form onFinish={submitForm}>
                <Space direction="vertical" size={6} style={{ width: "100%" }}>
                  <Divider />
                  <Row gutter={[0, 10]}>
                    <Col span={24}>
                      <Input
                        required
                        name="accumulateName"
                        label={
                          t("year_accumulate_list.label.Accumulate_name") + t('th')
                        }
                        placeholder={t("year_accumulate_list.label.Accumulate_name") + t('th')}
                        size="large"
                        regex={/^[\u0E00-\u0E7F0-9\s\p{P}\p{S}]*$/u}
                        formRegex={true}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        required
                        name="accumulateNameEn"
                        placeholder={t("year_accumulate_list.label.Accumulate_name") + t('en')}
                        size="large"
                        label={
                          t("year_accumulate_list.label.Accumulate_name") + t('en')
                        }
                        regex={/^[๐-๙a-zA-Z0-9\s\p{P}\p{S}]*$/u}
                        formRegex={true}
                      />
                    </Col>
                    <Col span={24}>
                      <Select
                        required
                        name="incomeDeductionId"
                        placeholder={
                          t("year_accumulate_list.label.Amount_Income_Deduction")
                        }
                        size="large"
                        label={
                          t("year_accumulate_list.label.Amount_Income_Deduction")
                        }
                        options={amountIncomeDeductionOptions}
                        onChange={(val) => {
                          const amountIncomeDeduction =
                            (
                              amountIncomeDeductionOptions.find(
                                (d) => d.value === val
                              ) || {}
                            ).nameEn || "";
                          setFieldValue("amountIncomeDeduction", amountIncomeDeduction);
                        }}
                      />
                    </Col>
                  </Row>
                  <div style={{ height: 12 }} />
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="year_accumulate_cancelBtn"
                        type="default"
                        onClick={() => {
                          Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                              <span>{t('are-you-sure-confirm-to-cancel')}</span>
                            ),
                            onOk() {
                              onCancel()
                              resetForm()
                            },
                            okText: t("common.confirm"),
                            cancelText: t("common.cancel"),
                          })
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button htmlType="submit" type="primary" style={{ backgroundColor: "var(--button-color)", height: "40px", borderRadius: "8px" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </Modal>

      <Space className={styles.container} direction="vertical" size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("masterdata.header"), href: "" },
            { title: t("year_accumulate_list.header") }
          ]} />
          <h2>{t("year_accumulate_list.header")}</h2>
        </Flex>
        <Row justify="end">
          <Space direction="horizontal" size={24}>
            <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {/* <a href="/employee/create"> */}
            {
              roles.includes("CREATE_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING") && <Button onClick={(e) => {
                onCreate();
              }} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                type="primary">
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  <span>{t('my_document.create')}</span>
                </Flex>
              </Button>
            }

            {/* </a> */}
          </Space>
        </Row>
        {useFilter && (
          <Card style={{ border: "solid 1px #EAECF0" }}>
            <YearAccumulateFilter
              amountIncomeDeductionOptions={amountIncomeDeductionOptions}
              onChange={onChange}
              onSubmit={onSearch}
              onCancel={onCancel}
              isLoading={isLoading}
            />
          </Card>
        )}
        <TableAntd
          columns={columns}
          dataSource={yearAccumulateList}
          onDelete={onDelete}
          onEdit={onEdit}
          loading={isLoading}
          pagination={pagination}
          onChange={onChange}
        />
      </Space>
    </MainLayout>
  );
};

export default YearAccumulateList;
